import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["terms", "privacy", "submit"]

  connect() {
    this.#updateSubmitState()
  }

  checkboxChanged() {
    this.#updateSubmitState()
  }

  #updateSubmitState() {
    this.submitTarget.disabled = !(this.termsTarget.checked && this.privacyTarget.checked)
  }
}
